export default __webpack_public_path__ + "static/media/join-code-footer.999a6d76.svg";